import React from 'react';
import { Routes, Route } from 'react-router-dom';

import PermissaoRoute from 'components/ui/PermissaoRoute';

import Lavanderia from './Lavanderia';
import Formulario from './Formulario';
import Lista from './Lista';

import Empresa from 'pages/Empresas'

const Lavanderias = () => {

  return (
    <Routes>
      <Route path={`:id`} element={<PermissaoRoute permissao="lavanderia.view_lavanderia"><Lavanderia/></PermissaoRoute>} />
      <Route path={`form`} element={<PermissaoRoute permissao="lavanderia.add_lavanderia" ><Formulario/></PermissaoRoute>} />
      <Route path={`empresa/*`} element={<Empresa/>} />
      <Route path={`:id/form`} element={<PermissaoRoute permissao="lavanderia.change_lavanderia"><Formulario/></PermissaoRoute>} />
      <Route index element={<PermissaoRoute permissao="lavanderia.view_lavanderia"><Lista/></PermissaoRoute>} />
    </Routes>
  );
};

export default Lavanderias;
